import { useIsDexcomPartnerUser } from '@src/hooks/useIsDexcomPartnerUser'
import { User } from '@src/utils'
import { DexcomConnectionStatus, MobileAppFeature } from '@src/types'
import { useDexcomConnection } from '@src/utils/hooks'

export const useShowSteloIntegrationPopupForDexcomUsers = () => {
  const isDexcomUser = useIsDexcomPartnerUser()
  const dexcomConnection = useDexcomConnection()
  const hasSteloApiAccess = User.hasFeature(MobileAppFeature.DexcomSteloApiIntegration)

  if (!isDexcomUser || !hasSteloApiAccess) {
    return false
  }

  if (!dexcomConnection) {
    return true
  }

  if (dexcomConnection.status === DexcomConnectionStatus.Invalidated) {
    return true
  }

  return false
}
